const api = '/api/v1/u001_p_login_Info_controller.php';
import axios from 'axios';
export const login_Info_repository =  {
    get(user_id){
        return  axios.get(`${api}?USER_ID=${user_id}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

